import styled from '@emotion/styled';

export const StyledHeader = styled.header`
  display: flex;
  background-color: #1d1d1b;
  color: white;
  height: 100px;
  justify-content: space-between;
  padding: 1rem;
  align-items: center;
  box-sizing: border-box;
  z-index: 100;

  img {
    max-width: 100%;
    display: block;
    height: 75px;
  }

  a {
    display: inline-block;
    width: 50%;
    &.logout {
      text-align: end;
      padding: 0 20px 0 0;
      cursor: pointer;
    }
  }
`;
